import { render, staticRenderFns } from "./ListingsList.vue?vue&type=template&id=b1039440&scoped=true"
import script from "./ListingsList.vue?vue&type=script&lang=js"
export * from "./ListingsList.vue?vue&type=script&lang=js"
import style0 from "./ListingsList.vue?vue&type=style&index=0&id=b1039440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1039440",
  null
  
)

export default component.exports